import PrintComponent from "components/common/custom/print/PrintComponents";
import { GetSingleEligibilityData } from "features/eliglibility/eligibility-check-list/config/eligibilityCheckListApi";
import BenefitsTable from "helpers/print/BenefitsTable/BenefitsTable";
import DCAF from "helpers/print/DCAF/DCAF";
import OCAF from "helpers/print/OCAF/OCAF";
import UCAF from "helpers/print/UCAF/UCAF";
import React, { useState } from "react";
import { Button, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  Printer,
  Gear,
  FileEarmark,
  ClipboardData,
  Gift,
} from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";

const FloatingPrintMenu = () => {
  const dispatch = useDispatch();
  const { eligibilityCheckData } = useSelector(
    (state) => state.eligibilityCheck
  );

  const { userData } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(false);
  const [showUCAf, setShowUCAF] = useState(false);
  const [showOCAf, setShowOCAF] = useState(false);
  const [showDCAf, setShowDCAF] = useState(false);
  const [showBenefits, setShowBenefits] = useState(false);
  const [printData, setPrintData] = useState(null);
  const actions = [
    { name: "UCAF", icon: <Printer />, color: "#2cb3f0" },
    { name: "OCAF", icon: <Printer />, color: "#4CAF50" },
    { name: "DCAF", icon: <Printer />, color: "#9C27B0" },
    { name: "Benefits", icon: <Printer />, color: "#FF9800" },
  ];

  const buttonStyle = {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    fontSize: "0px",
    boxShadow: "0 10px 25px -5px rgba(44, 179, 240, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    zIndex: 1001,
  };

  const handlePrint = async (type) => {
    if (type === "UCAF") {
      const response = await dispatch(
        GetSingleEligibilityData(eligibilityCheckData?.eligibilityid)
      ).unwrap();

      if (response?.success) {
        setShowUCAF(true);
        setPrintData(response?.data);
      }
    } else if (type === "DCAF") {
      const response = await dispatch(
        GetSingleEligibilityData(eligibilityCheckData?.eligibilityid)
      ).unwrap();

      if (response?.success) {
        setShowDCAF(true);
        setPrintData(response?.data);
      }
    } else if (type === "OCAF") {
      const response = await dispatch(
        GetSingleEligibilityData(eligibilityCheckData?.eligibilityid)
      ).unwrap();

      if (response?.success) {
        setShowOCAF(true);
        setPrintData(response?.data);
      }
    } else {
      const response = await dispatch(
        GetSingleEligibilityData(eligibilityCheckData?.eligibilityid)
      ).unwrap();

      if (response?.success) {
        setShowBenefits(true);
        setPrintData(response?.data);
      }
    }
  };

  return (
    <>
      {showUCAf && (
        <PrintComponent
          text=""
          onPrintOpen={() => {
            setShowUCAF(false);
            // setPrintableObj(null);
          }}
          child={
            <UCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}

      {showOCAf && (
        <PrintComponent
          text=""
          onPrintOpen={() => {
            setShowOCAF(false);
            // setPrintableObj(null);
          }}
          child={
            <OCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}
      {showDCAf && (
        <PrintComponent
          text=""
          onPrintOpen={() => {
            setShowDCAF(false);
            // setPrintableObj(null);
          }}
          child={
            <DCAF
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}

      {showBenefits && (
        <PrintComponent
          text=""
          onPrintOpen={() => {
            setShowBenefits(false);
            // setPrintableObj(null);
          }}
          child={
            <BenefitsTable
              printData={printData}
              printedName={userData?.employee?.emp_name || ""}
            />
          }
        />
      )}
      {open && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999999,
          }}
          onClick={() => setOpen(false)}
        />
      )}

      <div style={{ zIndex: open ? 999999999999999 : 9, position: "relative" }}>
        <Dropdown show={open} onToggle={setOpen} drop="up">
          <Dropdown.Toggle
            variant="primary"
            style={buttonStyle}
            id="dropdown-print-menu"
          >
            <Printer size={25} />
          </Dropdown.Toggle>

          <Dropdown.Menu
            style={{
              right: "75px",
              bottom: "0",
              border: "none",
              background: "transparent",
              boxShadow: "none",
              minWidth: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "15px",
              overflow: "hidden",
              position: "absolute",
              zIndex: 99999999999,
            }}
          >
            {actions.map((action) => (
              <Dropdown.Item
                key={action.name}
                onClick={() => handlePrint(action.name)}
                as="div"
                style={{
                  padding: 0,
                  background: "transparent",
                  border: "none",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    transition: "transform 0.2s, opacity 0.2s",
                    transform: open ? "translateX(0)" : "translateX(20px)",
                    opacity: open ? 1 : 0,
                  }}
                >
                  <Button
                    variant="light"
                    style={{
                      width: "45px",
                      height: "45px",
                      borderRadius: "50%",
                      background: action.color,
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                    }}
                    onClick={() => {}}
                  >
                    {React.cloneElement(action.icon, { size: 25 })}
                  </Button>
                  <span
                    style={{
                      color: action.color,
                      fontWeight: 500,
                      textShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {action.name}
                  </span>
                </div>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
};

export default FloatingPrintMenu;
